import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateBlog } from '../../redux/blog/blogSlice';
import { AppDispatch } from '../../redux/';

interface BlogPost {
  id: string;
  _id: string;
  title: string;
  content: string;
  status: 'draft' | 'pending_review' | 'published' | 'rejected';
  author: string;
  tags: string[];
  rejection_reason?: string | null;
  review_results?: string | null;
}


interface UpdateBlogHook {
  updatePost: (id: string, blogData: Partial<BlogPost>) => Promise<boolean>;
}

export function useUpdateBlog(): UpdateBlogHook {
  const dispatch = useDispatch<AppDispatch>();

  const updatePost = useCallback(
    async (id: string, blogData: Partial<BlogPost>): Promise<boolean> => {
      try {
        await dispatch(updateBlog({ id, blogData })).unwrap();
        return true;
      } catch (error) {
        console.error('Failed to update blog:', error);
        return false;
      }
    },
    [dispatch]
  );

  return { updatePost };
}
